export default __webpack_public_path__ + "a3343b834cb03dacf8ece8737ed21ab9.jpg";